import PageHeader from "../components/PageHeader";

function NotFound() {
  return <PageHeader>الصفحة غير موجودة</PageHeader>;
}

export default NotFound;
